import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'
import {
  AllowedAssetConfigDataNames,
  AllowedUpmLevels
} from '@refra/modules/refra-flexible-report/types'

export const useGetAssetConfigQuery = (
  upmType: AllowedUpmLevels,
  productionDataNames: AllowedAssetConfigDataNames[],
  upmIds: string[],
  enabled: boolean | undefined = false
) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'assetConfigData',
    params: [{upmIds, upmType, productionDataNames}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useGetAssetConfigQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching kiln nodes')

      spawnErrorToast(t('error.assetConfigData'))

      return false
    },
    enabled
  })
}
